import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import c from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import Header from '../components/header'
import {
  setoLogoPath, setBrand, setBranding, getAppThemes,
} from '../reducers/app'
import { selectBrand, selectThemes } from '../selectors/app'

export function Branding() {
  const dispatch = useDispatch()
  const brandName = useSelector(selectBrand)
  const themes = useSelector(selectThemes)

  const onChangeBrand = (v) => {
    const theme = themes.find((t) => t.id === v.value)
    const branding = {
      name: theme.brand_name,
      color: theme.color,
      logoUrl: theme.image_url,
      brandName: theme.brand_name,
      tabIconUrl: theme.tab_icon_url,
    }
    dispatch(setBranding(branding))
    localStorage.setItem('brand_name', branding.name)
    localStorage.setItem('brand_color', branding.color)
    localStorage.setItem('brand_logo', branding.logoUrl)
    localStorage.setItem('brand_name', branding.brandName)
    localStorage.setItem('tab_icon_url', branding.tabIconUrl)
  }

  const onClearLogo = () => {
    const branding = {
      name: 'akko',
      logoUrl: '/brands/akko.png',
      color: '#F3103D',
      brandName: 'AKKO Claims',
      tabIconUrl: '/favicons/favicon-16x16.png',
    }
    dispatch(setBranding(branding))
    localStorage.setItem('brand_name', branding.name)
    localStorage.setItem('brand_color', branding.color)
    localStorage.setItem('brand_logo', branding.logoUrl)
    localStorage.setItem('brand_name', branding.brandName)
    localStorage.setItem('tab_icon_url', branding.tabIconUrl)
  }

  useEffect(() => {
    dispatch(getAppThemes())
  }, [])
  return (
    <div className={c('page', brandName)}>
      <Header />
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-6">
            <Select
              onChange={onChangeBrand}
              className="multiselect"
              options={themes.map((t) => ({ value: t.id, label: t.brand_name }))}
              isClearable
            />
          </div>
        </div>
        <div className="mb-3">
          <button className="btn btn-primary" type="button" onClick={onClearLogo}>Remove brand logo</button>
        </div>
      </div>
    </div>
  )
}
export default Branding
